import { FacilityGroupSortOption } from '@rematter/frontend-lib-api-client';
import { FacilityGroupRecord } from '@rematter/modules/facilities/types/facilityGroup';

import { createQueryHook } from '~/shared/providers/api';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const useFacilityGroupsQuery = createQueryHook(
  'facilities.facilityGroups',
  (params: {
    searchTerm?: string;
    sorting?: FacilityGroupSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    facilityGroups: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        customAttributes: true,
        facilities: {
          id: true,
          facilityName: true,
          facilityType: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): { facilityGroups: FacilityGroupRecord[]; total?: number } => ({
      facilityGroups: data?.facilityGroups.entries.map((group) => ({
        id: group.id,
        name: group.name,
        customAttributes: group.customAttributes ?? {},
        facilities:
          group.facilities?.map((facility) => ({
            id: facility.id,
            facilityName: facility.facilityName,
            facilityType: facility.facilityType,
          })) ?? [],
        timestamps: {
          createdAt: parseZonedDateTime(group.timestamps.createdAt),
          updatedAt: parseZonedDateTime(group.timestamps.updatedAt),
        },
      })),
      total: data?.facilityGroups.page.total ?? undefined,
    }),
  },
);
